import { useWindowSize } from 'react-use';
import { useContext, useEffect } from 'react';

import { useEnableNewHotkeySystem } from '../../feature-flags/hooks/use-enable-new-hotkey-system';
import { Context as GlobalEventListenerContext } from '../components/global-event-listener/context';

type UseWindowResizeOptions = {
  enabled?: boolean;
};

export const useWindowResize = (
  onResize: (size: { width: number; height: number }) => void,
  { enabled = true }: UseWindowResizeOptions = {},
) => {
  const isNewHotkeySystemEnabled = useEnableNewHotkeySystem();
  const { subscribe } = useContext(GlobalEventListenerContext);

  useEffect(() => {
    if (isNewHotkeySystemEnabled) {
      return;
    }
    if (!enabled) {
      return;
    }

    const handleResize = () => {
      onResize({ width: global.window.innerWidth, height: global.window.innerHeight });
    };

    return subscribe('onResize', handleResize);
  }, [isNewHotkeySystemEnabled, enabled, onResize, subscribe]);

  const { width, height } = useWindowSize();

  useEffect(() => {
    if (!isNewHotkeySystemEnabled) {
      return;
    }
    if (!enabled) {
      return;
    }

    onResize({ width, height });
  }, [isNewHotkeySystemEnabled, width, height, enabled, onResize]);
};
